(function () {
  'use strict';
  angular
    .module('cbl.finanza.mf.directives')
    .service('FinDossierMovementsSrvc', [
      'FIN_CONSTANTS',
      function (CONSTANTS) {
        var numeroRapporto = null;
        var datasource = null;
        var gridMovimentiProdottoOptions = null;
        var gridApi = null;

        var inputFormMovimenti = {
          startDate: null,
          endDate: null,
          isin: null,
          descrizione: null
        };

        // Gestione delle viste
        var views = {
          defaultView: {
            title: 'Movimenti',
            url:
              CONSTANTS.BASE_ROOT +
              'widgets/finDossierMovements/states/finDossierMovements.states.table.html',
            visible: true,
            searchEnabled: true,
            type: 'TABLE'
          },
          listView: [
            {
              title: 'Movimenti',
              url:
                CONSTANTS.BASE_ROOT +
                'widgets/finDossierMovements/states/finDossierMovements.states.table.html',
              visible: true,
              searchEnabled: true,
              type: 'TABLE'
            },
            {
              title: 'Dettaglio movimento',
              url:
                CONSTANTS.BASE_ROOT +
                'widgets/finDossierMovements/states/finDossierMovements.states.details.html',
              visible: false,
              searchEnabled: false,
              type: 'DETAIL'
            }
          ]
        };

        var currentItem = null;
        // Determina se sto facendo una ricerca (e quindi mostro il loader) o se non ho
        // trovato risultati (e mostro il messaggio di nessun elemento trovato)
        var searchInProgress = false;

        return {
          numeroRapporto: numeroRapporto,
          datasource: datasource,

          gridMovimentiProdottoOptions: gridMovimentiProdottoOptions,
          gridApi: gridApi,

          views: views,
          currentItem: currentItem,
          searchInProgress: searchInProgress,

          inputFormMovimenti: inputFormMovimenti
        };
      }
    ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierMovements/finDossierMovementsSrvc.js
 ** module id = 35
 ** module chunks = 1 2
 **/